import { ExperiencePerformanceTypes } from '@atlassian/ufo-experimental';
import {
	type CustomHistogramConfig,
	type ExperienceData,
	type HistogramConfig,
	type InteractionHistogramConfig,
	type PageLoadExperienceData,
	type PageLoadHistogramConfig,
	type PageSegmentLoadHistogramConfig,
	type ExperiencePerformanceConfig as PerformanceConfig,
} from '@atlassian/ufo-experimental/types';

import { CustomMetricKeys } from './CustomMetricKeys';
import { InlineResultMetricKeys } from './InlineResultMetricKeys';
import { LoadMetricKeys } from './LoadMetricKeys';

export const getHistogram: any = (
	data: ExperienceData | PageLoadExperienceData,
	performanceConfig: PerformanceConfig | null,
	isInitial?: boolean,
) => {
	let histogram: HistogramConfig = {};
	if (data.performanceConfig?.histogram) {
		histogram = data.performanceConfig.histogram;
	} else if (performanceConfig?.histogram) {
		histogram = performanceConfig.histogram;
	}

	if (histogram) {
		const histograms = histogram[data.performanceType];
		switch (data.performanceType) {
			case ExperiencePerformanceTypes.PageLoad:
			case ExperiencePerformanceTypes.PageSegmentLoad:
				const histogramType =
					isInitial !== undefined && isInitial === true ? 'initial' : 'transition';
				return histograms
					? {
							[LoadMetricKeys.ttiHistograms]: (
								histograms as PageLoadHistogramConfig | PageSegmentLoadHistogramConfig
							)[histogramType].tti,
							[LoadMetricKeys.fmpHistograms]: (
								histograms as PageLoadHistogramConfig | PageSegmentLoadHistogramConfig
							)[histogramType].fmp,
						}
					: {};
			case ExperiencePerformanceTypes.InlineResult:
				return histograms
					? {
							[InlineResultMetricKeys.resultHistograms]: (histograms as InteractionHistogramConfig)
								.result,
							[InlineResultMetricKeys.responseHistograms]: (
								histograms as InteractionHistogramConfig
							).response,
						}
					: {};
			case ExperiencePerformanceTypes.Custom:
				return histograms
					? {
							[CustomMetricKeys.durationHistograms]: (histograms as CustomHistogramConfig).duration,
						}
					: {};
		}
	}

	return undefined;
};
